import CreditCardUtil from './CreditCardUtil';
import templateStr from 'text!./templates/credit-card-details.html';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,

        scope: {
            creditCardDetails: '=gwPlCreditCardDetails'
        },

        controller: ['$scope', function (scope) {
            scope.creditCardDetails.value = scope.creditCardDetails.value || {};
            scope.issuers = scope.creditCardDetails.creditCardIssuer.aspects.availableValues;
            scope.creditCardDetails.creditCardIssuer.value = scope.creditCardDetails.creditCardIssuer.value || scope.issuers[0];

            scope.cardMask = {};

            // watcher to update the input mask on the card number field depending on issuer.
            scope.$watch('creditCardDetails.creditCardIssuer.value', function () {
                var newValue = scope.creditCardDetails.creditCardIssuer.value;
                if (!newValue) {
                    return;
                }

                var newMask = CreditCardUtil.getInputValidatorForIssuerCode(newValue.code);
                scope.cardMask = newMask;

                var maskLength = newMask.replace(/-/g, '').length; // Get the length of the string of digits unformatted
                var cardNumberValue = scope.creditCardDetails.creditCardNumber.value;
                if (cardNumberValue && cardNumberValue.length > maskLength) {
                    scope.creditCardDetails.creditCardNumber.value = cardNumberValue.substring(0, maskLength); // Truncate if the previous value is too big
                }
            });
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/paymentdetails/CreditCardDetailsDirective.js
// module id = 1054
// module chunks = 0